import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDroppable} from '@dnd-kit/core';
import {SortableContext, horizontalListSortingStrategy} from '@dnd-kit/sortable';
import {Button} from '@tickchak/react-share/app';
import * as css from './LectureTimeRow.css';
import LectureCard from '../lectureCard/LectureCard';
import ClockSettings from '../../../../assets/icons/ClockSettings';
import PlusThin from '../../../../assets/icons/PlusThin';
import {TLectureTimeGroup} from '../../../../redux/timetable/timetable.type';

interface LectureTimeRowProps {
    timeGroup: TLectureTimeGroup;
    expanded?: boolean;
    isFirst?: boolean;
    onAddLecture?: () => void;
    onTicketsClick?: (lecture: TLectureTimeGroup['lectures'][number]) => void;
}

function LectureTimeRow({
    timeGroup,
    expanded = true,
    isFirst = false,
    onAddLecture = () => {},
    onTicketsClick = () => {},
}: LectureTimeRowProps) {
    const {time, rawTime, lectures = [], startIndex = 0} = timeGroup;
    const {t} = useTranslation('timetable');
    const {setNodeRef} = useDroppable({id: rawTime});
    const itemIds = lectures.map(l => l.ttid);

    return (
        <css.row>
            <css.timeLabel>
                {time}
                {isFirst && <ClockSettings />}
            </css.timeLabel>
            <css.lecturesArea ref={setNodeRef}>
                <css.addLecture expanded={expanded} onClick={onAddLecture}>
                    <css.addButton>
                        <PlusThin color="white" />
                    </css.addButton>
                    <css.mobileBtnWrapper>
                        <Button variant="brand" size="chip" iconStart={<PlusThin />} onClick={onAddLecture}>
                            {t('addHour')}
                        </Button>
                    </css.mobileBtnWrapper>
                </css.addLecture>
                <SortableContext items={itemIds} strategy={horizontalListSortingStrategy}>
                    {lectures.map((lecture, i) => (
                        <LectureCard
                            key={lecture.ttid}
                            lecture={lecture}
                            index={startIndex + i}
                            expanded={expanded}
                            onTicketsClick={() => onTicketsClick(lecture)}
                        />
                    ))}
                </SortableContext>
            </css.lecturesArea>
        </css.row>
    );
}

export default LectureTimeRow;
